<template>
  <!-- Bed App Start -->
  <div class="product-bed-app">
    <div class="app">
      <div class="app__content">
        <div class="content__title" data-aos="fade-up" :data-aos-duration="duration">
          <span>{{$t('bed.app.title')}}</span>
        </div>
        <div class="content__sub-title" data-aos="fade-up" :data-aos-duration="duration">
          <span v-html="$t('bed.app.sub-title')"></span>
        </div>
      </div>
      <div class="app__image">
        <!-- language check -->
        <template v-if="$i18n.locale() === 'ko'">
          <!-- ** lang KO Start ** -->
          <picture data-aos="fade-up" :data-aos-duration="duration">
            <img src="../../assets/img/img_bed_app_1_ko.png" alt="app"/>
            <span class="app__image__text--ko">{{$t('bed.app.monitoring')}}</span>
          </picture>
          <picture data-aos="fade-up" :data-aos-duration="duration">
            <img src="../../assets/img/img_bed_app_2_ko.png" alt="app"/>
            <span class="app__image__text--ko">{{$t('bed.app.monitoring')}}</span>
          </picture>
          <picture data-aos="fade-up" :data-aos-duration="duration">
            <img src="../../assets/img/img_bed_app_popup_ko.png" alt="app"/>
          </picture>
          <!-- ** lang KO End ** -->
        </template>
        <template v-else>
          <!-- ** lang EN Start ** -->
          <picture data-aos="fade-up" :data-aos-duration="duration">
            <img src="../../assets/img/img_bed_app_1_en.png" alt="app"/>
            <span>{{$t('bed.app.monitoring')}}</span>
          </picture>
          <picture data-aos="fade-up" :data-aos-duration="duration">
            <img src="../../assets/img/img_bed_app_2_en.png" alt="app"/>
            <span>{{$t('bed.app.monitoring')}}</span>
          </picture>
          <picture data-aos="fade-up" :data-aos-duration="duration">
            <img src="../../assets/img/img_bed_app_popup_en.png" alt="app"/>
          </picture>
          <!-- ** lang EN Start ** -->
        </template>
      </div>

      <!-- Main Line Start -->
      <div class="bed__main-line"></div>
      <!-- Main Line End -->
    </div>
  </div>
  <!-- Bed App End -->
</template>

<script>
import { FadeUpMixin } from '../mixins/FadeUp';

export default {
  name: 'BedApp',
  data() {
    return {
    };
  },
  mixins: [FadeUpMixin],
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/constant';
  @import '../../assets/scss/mixins';

  /* ------------------
    :: Product Bed App CSS
    ------------------ */
  .product-bed-app {
    padding: 0 40px 135px;
    @include flexbox;
    @include flex-direction(column);
    @include align-items(center);

    .app {
      width: 100%;
      max-width: 1518px;
      position: relative;
      flex-shrink: 0;
    }
  }

  .bed__main-line {
    display: none;
  }

  .app__image {
    @include flexbox;
    @include flex-direction(row);
    @include flex-wrap(wrap);
    @include justify-content(center);
    flex-shrink: 0;
    & > picture {
      position: relative;
      flex: 0 0 50%;
      max-width: 50%;
      flex-shrink: 0;
      & > img {
        width: 100%;
      }

      & > span {
        width: auto;
        position: absolute;
        left: -10px;
        top: 13%;

        writing-mode: vertical-lr;
        -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);

        font-size: 16px;
        color: $color-black;

        &.app__image__text--ko {
          left: -25px;

          writing-mode: inherit;
          -webkit-transform: rotate(-90deg);
          -ms-transform: rotate(-90deg);
          transform: rotate(-90deg);
        }
      }

      &:nth-of-type(3) {
        position: absolute;
        bottom: 0;
        right: 0;
        max-width: 40%;
        & > img {
          animation: fadeIn 2s infinite alternate;
        }
      }
    }
  }
  @media (min-width: 576px) {
    .app__image {
      & > picture {
        & > span {
          left: 0;
          top: 86px;

          &.app__image__text--ko {
            left: -20px;
            top: 110px;
          }
        }
      }
    }
  }
  @media (min-width: 992px) {
    .product-bed-app {
      padding: 0 40px 158px;
    }
    .app__image {
      position: relative;
      height: 1090px;
      & > picture {
        position: absolute;
        width: 420px;
        &:nth-of-type(1) {
          top: 0;
          right: 0;
        }
        &:nth-of-type(2) {
          top: 420px;
          right: 420px;
        }
        &:nth-of-type(3) {
          top: 691px;
          right: 624px;
          width: 348px;
        }
        & > img {
          width: 100%;
        }
      }
    }
  }
  @media (min-width: 1518px) {
    .bed__main-line {
      display: block;
      width: 1px;
      height: 1950px;
      background-color: $color-header-gray;
      position: absolute;
      top: -290px;
      right: 200px;
      z-index: -1;
    }
  }
  /* ------------------
    :: App Animation CSS
    ------------------ */
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
</style>
